import React from "react";
import { motion } from "framer-motion";
import { Building2, Radio, Users, Target, LineChart } from "lucide-react";
import { Logo } from "./Logo";

const icons = [Building2, null, Radio, Users, Target];

export const EcosystemDiagram = ({ nodes }) => {
  return (
    <div className="relative w-full" data-testid="ecosystem-diagram">
      <div className="relative flex flex-col lg:flex-row items-center justify-between gap-4 lg:gap-2">
        {nodes.map((label, i) => {
          const isCenter = i === 1;
          const Icon = icons[i];
          return (
            <React.Fragment key={i}>
              <motion.div
                initial={{ opacity: 0, scale: 0.7, y: 20 }}
                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                className={`relative z-10 flex flex-col items-center justify-center rounded-2xl shrink-0
                  ${isCenter
                    ? "w-40 h-40 md:w-48 md:h-48 wanm-gradient-bg text-white shadow-[0_20px_60px_rgba(252,12,201,0.4)]"
                    : "w-32 h-32 md:w-36 md:h-36 bg-white border border-wanm-offwhite shadow-[0_8px_32px_rgba(53,53,53,0.06)]"}`}
              >
                {isCenter ? (
                  <>
                    <Logo variant="white" height={26} to={false} testId="eco-wanm" />
                    <span className="mt-3 text-xs font-bold uppercase tracking-widest text-white/80">{label}</span>
                  </>
                ) : (
                  <>
                    <div className="w-12 h-12 rounded-xl bg-wanm-offwhite flex items-center justify-center mb-3">
                      {Icon ? <Icon className="text-wanm-red" size={24} /> : <LineChart className="text-wanm-red" size={24} />}
                    </div>
                    <span className="text-sm font-black text-wanm-dark text-center px-2">{label}</span>
                  </>
                )}
              </motion.div>

              {i < nodes.length - 1 && (
                <div className="relative flex items-center justify-center lg:flex-1 lg:h-1 h-8 w-1 lg:w-auto">
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="lg:w-full lg:h-[3px] w-[3px] h-full bg-wanm-offwhite rounded-full overflow-hidden">
                      <motion.div
                        className="wanm-gradient-bg w-full h-full origin-left"
                        initial={{ scaleX: 0, scaleY: 0 }}
                        whileInView={{ scaleX: 1, scaleY: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.2 + i * 0.12 }}
                      />
                    </div>
                  </div>
                  <motion.div
                    className="absolute w-2.5 h-2.5 rounded-full wanm-gradient-bg"
                    animate={{ x: [0, 12, 0], opacity: [0.4, 1, 0.4] }}
                    transition={{ duration: 2, repeat: Infinity, delay: i * 0.3 }}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default EcosystemDiagram;
